export default __webpack_public_path__ + "static/media/catpunk-logo-dark.275390ec.png";